/**
 * This is a temporary workaround to bootstrap Angular into the embed-report application.
 * Eventually, this will be moved to a proper Angular application once all the dependencies
 * are moved to separate Nx modules.
 *
 * This file mimics a `main.ts`
 * The `embed-report.module.ts` is the equivalent of `app.module.ts`.
 */

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { EmbedReportModule } from './embed-report.module';

if (process.env.NODE_ENV) {
  // Pulled from WebpackEnvironmentPlugin instead of the proper environment.ts
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(EmbedReportModule)
  .catch((err) => console.error(err));
